export enum GrappleType {
    Multi = "mg",
    Stone = "sg",
    Sorting = "sog",
  }